import React from 'react';
import { useCan } from '../store';
import { formatTime } from '../utils/time';

// 采集资产同步状态胶囊 + 手动同步按钮 (2026-10-20 从 UgcShareList 抽出, UGC / prism 三页共用).
// 只管展示; 触发与轮询见 utils/useSyncPolling.ts.

export interface SyncBarState {
    /** idle / running / failed */
    status: string;
    lastOkAt: number;
    durationMs: number;
    failStreak: number;
    lastError: string;
    /** timer / manual */
    triggerBy: string;
}

function fmtDuration(ms: number): string {
    if (!ms) return '—';
    return ms >= 1000 ? `${(ms / 1000).toFixed(1)}s` : `${ms}ms`;
}

export default function SyncBar({
    state,
    syncing,
    onSync,
    sourceText,
    note,
}: {
    state: SyncBarState | null;
    syncing: boolean;
    onSync: () => void;
    /** 第二行的来源说明, 如「来源 xtool-community · 每小时自动」 */
    sourceText: string;
    /** 第二行追加的提示 (如「回填中」), 可空 */
    note?: React.ReactNode;
}) {
    const running = syncing || state?.status === 'running';
    const canSync = useCan('data_asset', 'update');
    return (
        <div className="flex items-center gap-3">
            {state && (
                <div className="text-xs text-slate-500 text-right leading-5">
                    <div>
                        {state.status === 'failed' ? (
                            <span className="text-rose-600" title={state.lastError}>
                                ⚠ 上次同步失败 (连续 {state.failStreak} 次)
                            </span>
                        ) : (
                            <>
                                最近同步 {formatTime(state.lastOkAt)} · 耗时{' '}
                                {fmtDuration(state.durationMs)}
                            </>
                        )}
                    </div>
                    <div className="text-[11px] text-slate-400">
                        {sourceText} · {state.triggerBy === 'manual' ? '上次为手动' : '上次为定时'}
                        {note ? <> · {note}</> : null}
                    </div>
                </div>
            )}
            <button
                type="button"
                className="btn-primary"
                disabled={running}
                onClick={onSync}
                hidden={!canSync}
            >
                {running ? '同步中…' : '↻ 手动同步'}
            </button>
        </div>
    );
}
